import { render, staticRenderFns } from "./action-form.vue?vue&type=template&id=247456a5&"
import script from "./action-form.vue?vue&type=script&lang=js&"
export * from "./action-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports